import { useEffect, useMemo, useState } from 'react';

const getCategory = (breadcrumbs) => {
  if (breadcrumbs && breadcrumbs[breadcrumbs.length - 1]) {
    return breadcrumbs[breadcrumbs.length - 1]?.displayName || '';
  }
  return '';
};

export const useBreadcrumbDataInitialiser = (breadcrumbs) => {
  const defaultValue = useMemo(
    () => ({
      breadcrumbs: breadcrumbs || [],
      category: getCategory(breadcrumbs),
    }),
    [breadcrumbs]
  );

  const [returnValue, setReturnValue] = useState(defaultValue);

  useEffect(() => {
    setReturnValue(defaultValue);
  }, [defaultValue]);

  return returnValue;
};
